import './assets/app.css'
import './assets/element-plus.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import ElementPlus from 'element-plus'
import App from './App.vue'
import router from './routes'
import fontAwesomeSetup from "./fontAwesomeSetup";
import {QueryClient, VueQueryPlugin} from "@tanstack/vue-query";
import {createHead} from "@unhead/vue/client";
import * as Sentry from "@sentry/vue";
import {createGtm} from "@gtm-support/vue-gtm";

const app = createApp(App)

Sentry.init({
  app,
  dsn: "https://35f96f4e6a253a5e9870a1be14a539ce@o4508054233481216.ingest.de.sentry.io/4509871619244112",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT ?? 'production',
});

const pinia = createPinia();
const head = createHead()
pinia.use(piniaPluginPersistedState);

app.use(pinia)
app.use(ElementPlus);
app.use(router)
app.use(head)
app.use(createGtm({
  id: 'GTM-WKG9NQM5',
  vueRouter: router
}))

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30000
    }
  }
})
app.use(VueQueryPlugin, {
  queryClient
})

app.component('font-awesome-icon', fontAwesomeSetup)

app.mount('#app')
